import { render, staticRenderFns } from "./Telemedicina.vue?vue&type=template&id=22dd9f20&scoped=true"
import script from "./Telemedicina.vue?vue&type=script&lang=js"
export * from "./Telemedicina.vue?vue&type=script&lang=js"
import style0 from "./Telemedicina.vue?vue&type=style&index=0&id=22dd9f20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dd9f20",
  null
  
)

export default component.exports